/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

// Used to generate the requirejs layers bundle
// Only declare the entry points, not all modules!
define([
	'./widget/layers',
	'../datatray/layers',
	'./dashboard/layers',
	'./dashboard/customViz/CustomVizService',
	'./dashboard/actions/filterDock/ActiveFilterView',
	'../extensions/layers',

	// The following files only have uses in "package.json type" features.
	// If they were moved there, we would not need these entries.
	'./dashboard/queryService/api/QueryAPI2',
	'./content/forecast/api/ForecastAPI',
	'./content/smartAnnotations/api/SmartAnnotationsAPI',
	'./content/smartAnnotations/api/DeprecatedSmartAnnotationsAPI',
	'./content/smartsExecution/api/SmartsExecutionAPI',
	'./content/visIndicators/api/VisIndicatorsProviderAPI',
	'./content/selections/dataPointSelections/api/DataPointSelectionProviderAPI',
	// @todo: should be moved to dssQueryService feature component, where it is instantiated
	'./content/dataQueryExecution/postProcess/PostProcessOlapProperties'
], () => {});
